<template>
  <v-data-table
    mobile-breakpoint="0"
    :items-per-page="-1"
    item-key="id"
    :headers="headers"
    :items="sortPeriods"
    v-bind="this.$attrs"
    hide-default-footer
    loading-text="Đang Tải"
    :loading="loading"
  >
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">
        <div>Hiện tại chưa có kỳ thu/đóng trong danh sách.</div>
      </div>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link :to="'/tuition-fee-detail-period/' + item.id" style="text-decoration: none">
        {{ item.title | convertFullDate }}
      </router-link>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="getStatus(item.status).color" label>
        <span class="white--text">{{ getStatus(item.status).status }}</span>
      </v-chip>
    </template>
    <template v-slot:[`item.last`]="{ item }">
      <span v-if="item.status === 'finished' || item.status === 'running'"
        >{{ item.updatedAt | ddmmyyyy }}, lúc {{ item.updatedAt | hhmm }}</span
      >
    </template>
    <template v-slot:[`item.person`]="{ item }">
      <router-link class="text-decoration-none" :to="getLink(item.generatedBy)">{{
        item.generatedBy && item.generatedBy.name
      }}</router-link>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-btn icon @click="showDetailPeriod(item.id)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { sortPeriod } from '../head-fee/helper/period'

const originHeaders = [
  {
    text: 'Kỳ đóng',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Tổng kết lần cuối',
    value: 'last',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Người thực hiện',
    value: 'person',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true,
    width: '10%'
  }
]

export default {
  data() {
    return {
      headers: this.propHeaders && this.propHeaders.length ? this.propHeaders : originHeaders,
      originHeaders: originHeaders,
      selected: [],
      groupTableOptions: {}
    }
  },

  computed: {
    ...mapGetters({
      periods: 'tuitionFeePeriod/periods',
      loading: 'tuitionFeePeriod/loading'
    }),
    sortPeriods() {
      let periods = sortPeriod(this.periods)
      return periods
    }
  },
  methods: {
    getStatus(status) {
      switch (status) {
        case 'created':
          return { color: '#D3D3D3', status: 'Chưa tổng kết' }
        case 'running':
          return { color: '#F4BB43', status: 'Đang tổng kết' }
        case 'finished':
          return { color: '#46BE8A', status: 'Đã tổng kết' }
      }
    },
    getLink(person) {
      if (person && person.id) {
        return `/staff/${person.id}`
      } else return '#'
    },
    showDetailPeriod(id) {
      this.$router.push({ path: `tuition-fee-detail-period/${id}` })
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
